/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import { Button } from 'tc-client-common';
import PropTypes from 'prop-types';
import CModalWindow from '../common/modal/modalWindow.component.container';
import Notification from '../common/notification/notification.component';
import { ERROR_LOADING_HELPDESK, CLOSE } from '../../const';
import HelpdeskContainer from './helpdesk.container';

class HelpdeskModal extends Component {
  render() {
    let body;
    if (this.props.helpdeskError) {
      body = <Notification type="error" data={ERROR_LOADING_HELPDESK} />;
    } else {
      body = <HelpdeskContainer />;
    }

    return (
      <div>
        {body}
        <div className="tc-modal-footer fixed">
          <Button type="close" theme="default" handleClick={() => this.props.closeModal()} label={CLOSE} />
        </div>
      </div>
    );
  }
}

HelpdeskModal.propTypes = {
  helpdeskError: PropTypes.string,
  closeModal: PropTypes.func
};

HelpdeskModal.contextTypes = {
  router: PropTypes.object.isRequired
};

export default HelpdeskModal;
